/* SHYM wishlist — localStorage based (no app required)
   - Hearts on product cards toggle save/remove
   - Header heart shows a count badge and links to /pages/wishlist
   - The wishlist page (rendered with all product cards hidden) shows only saved items
*/
(function () {
  var KEY = 'shym-wishlist';

  function get() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function save(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  function has(handle) { return get().indexOf(handle) !== -1; }
  function toggle(handle) {
    var list = get();
    var i = list.indexOf(handle);
    if (i === -1) { list.push(handle); } else { list.splice(i, 1); }
    save(list);
    return list;
  }

  function markToggles() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-wishlist-handle');
      var active = has(handle);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function updateCount() {
    var n = get().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  function renderWishlistPage() {
    var page = document.querySelector('[data-wishlist-page]');
    if (!page) return;
    var list = get();
    var shown = 0;
    page.querySelectorAll('[data-wishlist-handle]').forEach(function (card) {
      var inList = list.indexOf(card.getAttribute('data-wishlist-handle')) !== -1;
      card.hidden = !inList;
      if (inList) shown++;
    });
    var empty = page.querySelector('[data-wishlist-empty]');
    var grid = page.querySelector('[data-wishlist-grid]');
    if (empty) empty.hidden = shown !== 0;
    if (grid) grid.hidden = shown === 0;
  }

  function refresh() {
    markToggles();
    updateCount();
    renderWishlistPage();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-wishlist-handle');
    if (!handle) return;
    toggle(handle);
    refresh();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();
